import type { CookieCircuitBreakerConfig } from '@atlassian/jira-route-types/src/JiraSpaRoute.tsx';
import { expVal } from '@atlassian/jira-feature-experiments';
import killswitch from '@atlassian/jira-killswitch';
import { fg } from '@atlassian/jira-feature-gating';

export function getSsrCircuitBreaker(): CookieCircuitBreakerConfig {
	return {
		isSetCookieEnabled: fg('empanada_nin_ssr_cookie_circuit_breaker_monitoring'),
		isMonitoringEnabled: fg('empanada_nin_ssr_cookie_circuit_breaker_monitoring'),
		isBailoutEnabled:
			fg('empanada_nin_ssr_cookie_circuit_breaker') && !killswitch('issue-navigator-cookie-cb'),
		cookieKey: 'nin',
		windowSize: expVal('empanada_nin_ssr_cookie_cb_optimisation', 'windowSize', 10),
		halfOpenForCount: expVal('empanada_nin_ssr_cookie_cb_optimisation', 'halfOpenForCount', 5),
		threshold: expVal('empanada_nin_ssr_cookie_cb_optimisation', 'threshold', 0.5),
		keepOpenCount: expVal('empanada_nin_ssr_cookie_cb_optimisation', 'keepOpenCount', 15),
	};
}
